import { render, staticRenderFns } from "./NavigationMenuDropdown.vue?vue&type=template&id=24597a8b&scoped=true"
import script from "./NavigationMenuDropdown.vue?vue&type=script&lang=js"
export * from "./NavigationMenuDropdown.vue?vue&type=script&lang=js"
import style0 from "./NavigationMenuDropdown.vue?vue&type=style&index=0&id=24597a8b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24597a8b",
  null
  
)

export default component.exports